module.exports = __webpack_public_path__ + "img/katarina_events_16.2a3ab44a.jpg";